import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams, useHistory } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { LuChevronLeft } from 'react-icons/lu';
import { FaExclamationCircle } from 'react-icons/fa';

import { LoadingIcon } from '_components/_shared';
import { Button, Card } from '_components/_core';

import { ChargeHero, ChargeHeader, ChargePayment, ChargeCustomer } from './components';

function ChargeDetails({ onFetchChargeById }) {
  const { id } = useParams();

  const history = useHistory();

  const [isLoading, setIsLoading] = useState(true);
  const [charge, setCharge] = useState(null);

  useEffect(() => {
    setIsLoading(true);

    const errorCallback = () => {
      setIsLoading(false);
    };

    onFetchChargeById(
      id,
      foundCharge => {
        setCharge(foundCharge);
        setIsLoading(false);
      },
      errorCallback,
    );
  }, [onFetchChargeById, id]);

  const handleBack = () => {
    history.goBack();
  };

  if (isLoading) {
    return (
      <Container className="content-wrapper">
        <div className="d-flex flex-column align-items-center justify-content-center p-5">
          <LoadingIcon size="lg" />
        </div>
      </Container>
    );
  }

  if (!charge) {
    return (
      <Container fluid className="content-wrapper">
        <Card className="p-4 d-flex justify-content-center align-items-center">
          <FaExclamationCircle className="text-info" size={30} />
          <h4 className="mt-3">Cobrança não encontrada</h4>
          <p>Não foi possível encontrar informações para esta cobrança.</p>
          <Button variant="link" onClick={() => history.goBack()}>
            Voltar
          </Button>
        </Card>
      </Container>
    );
  }

  return (
    <Container className="content-wrapper">
      <div className="mb-4">
        <Button
          variant="link"
          className="p-0 d-flex align-items-center"
          onClick={handleBack}
        >
          <LuChevronLeft className="mr-1" />
          Voltar para cobranças
        </Button>
      </div>

      <ChargeHeader charge={charge} />
      <ChargeHero charge={charge} />
      <ChargeCustomer charge={charge} />
      <ChargePayment charge={charge} />
    </Container>
  );
}

ChargeDetails.propTypes = {
  onFetchChargeById: PropTypes.func.isRequired,
  charge: PropTypes.object,
};

ChargeDetails.defaultProps = {
  charge: null,
};

export default ChargeDetails;
